export * from './footer/footer.component';
export * from './header/header.component';
export * from './download/download.component';
export * from './upload/upload.component';
export * from './release-notes/release-notes.component';
export * from '../views/page2/page2.component';